<script setup>
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-vue-next'

const props = defineProps({
  label: { type: String, required: false, default: 'Please wait' },
})
</script>

<template>
  <Button disabled>
    <Loader2 class="w-4 h-4 mr-2 animate-spin" />
    <slot />
  </Button>
</template>
